export const setCompany = (value) => {
    return {
      type: 'SET_COMPANY',
      payload: { data: value }
    };
  };